<template>
    <div v-if="journal">


        <v-card class="my-4" flat>
            <v-card-title>
                {{ $t('singleJournal.fulfillment') }}
            </v-card-title>
            <v-data-table
                    :headers="fulfillmentHeaders"
                    :items="journal.fulfillment.data"
                    :must-sort="true"
                    hide-default-footer
                    disable-sort
            >
            </v-data-table>
            <v-divider></v-divider>
            <v-card-text>
                {{ $t('singleJournal.notes') }}
                <ul>
                    <li>{{ $t('journalDetail.ptaNote') }}</li>
                </ul>
            </v-card-text>

        </v-card>
        <v-card class="my-4" flat>
            <v-card-title>
                <div>
                    <div>{{ $t('segments.oa') }}</div>
                    <div class="body-1" v-if="journal.oa.bronze_oa_embargo_months">
                        <strong>{{ $t('singleJournal.delayedOA') }} ({{journal.oa.bronze_oa_embargo_months}}mo):</strong>
                        {{ $t('journalDetail.delayedOANote', {months: journal.oa.bronze_oa_embargo_months}) }}
                    </div>

                </div>
            </v-card-title>
            <v-data-table
                    :headers="oaHeaders"
                    :items="journal.oa.data"
                    :must-sort="true"
                    hide-default-footer
                    disable-sort
            >
            </v-data-table>
            <v-divider></v-divider>
            <v-card-text>
                {{ $t('singleJournal.notes') }}
                <ul>
                    <li>{{ $t('journalDetail.greenNote') }}</li>
                </ul>
            </v-card-text>
        </v-card>

        <v-card class="my-4" flat>
            <v-card-title>
                {{ $t('singleJournal.impact') }}
            </v-card-title>
            <v-data-table
                    :headers="impactHeaders"
                    :items="journal.impact.data"
                    :must-sort="true"
                    hide-default-footer
                    disable-sort
            >
            </v-data-table>
            <v-divider></v-divider>
        </v-card>

        <v-card class="my-4" flat>
            <v-card-title>
                {{ $t('singleJournal.subscriptionCostLabel') }}
            </v-card-title>
            <v-card-text>
                <span v-if="journal.cost.subscribed">{{ $t('journalDetail.currentlySubscribed') }}</span>
                <span v-if="!journal.cost.subscribed">{{ $t('journalDetail.currentlyNotSubscribed') }}</span>
            </v-card-text>
            <v-card-text>
                <span>cpu: {{ journal.top.cpu }} </span>
            </v-card-text>

            <v-data-table
                    :headers="costHeaders"
                    :items="journal.cost.data"
                    :must-sort="true"
                    hide-default-footer
            >
            </v-data-table>
            <v-divider></v-divider>
        </v-card>

        <!--<v-card class="my-4" flat>-->
            <!--<v-card-title>-->
                <!--APC cost-->
            <!--</v-card-title>-->

            <!--<v-card-text class="body-1">-->
                <!--<div>-->
                    <!--Your institution's projected annual fractional authorship in this journal-->
                    <!--(fractional-->
                    <!--authorship = <em>number of authors from your institution</em> divided by <em>total-->
                    <!--coauthors</em> for each paper): <strong>{{-->
                    <!--journal.apc.annual_projected_fractional_authorship || "none found" }}</strong>-->
                <!--</div>-->
                <!--<div>-->
                    <!--This journal's APC price: <strong>{{ journal.apc.apc_price || "none found"}}</strong>-->
                <!--</div>-->
                <!--<div>-->
                    <!--Adjusted (fractional) projected annual APC spend from authors at your-->
                    <!--institution:-->
                    <!--<strong>{{-->
                        <!--journal.apc.annual_projected_cost || "none found" }}</strong>-->
                <!--</div>-->
            <!--</v-card-text>-->
            <!--<v-divider></v-divider>-->
        <!--</v-card>-->


        <v-card flat>
            <v-card-title>
                <v-switch
                        color="primary"
                        v-model="showApi"
                ></v-switch>
                {{ $t('singleJournal.apiResponse') }}
            </v-card-title>
            <v-card-text v-if="showApi">
                                    <pre>
                                        {{journal}}
                                    </pre>
            </v-card-text>
        </v-card>


    </div>
</template>

<script>
    import {api} from "../../api";
    import {mapGetters} from 'vuex'


    export default {
        name: 'SingleJournal',
        components: {},
        props: ["journal",],
        data: () => ({
            showApi: false,
        }),
        computed: {
            ...mapGetters([
                "scenarioId"
            ]),
            issnl() {
                return this.journal.issn_l
            },
            fulfillmentHeaders() {
                if (!this.journal) return []
                return this.translateHeaders(this.journal.fulfillment.headers, 'fulfillment')
            },
            oaHeaders() {
                if (!this.journal) return []
                return this.translateHeaders(this.journal.oa.headers, 'oa')
            },
            impactHeaders() {
                if (!this.journal) return []
                return this.translateHeaders(this.journal.impact.headers, 'impact')
            },
            costHeaders() {
                if (!this.journal) return []
                return this.translateHeaders(this.journal.cost.headers, 'cost')
            },
        },
        methods: {
            translateHeaders(headers, sectionType) {
                const keyMap = {
                    fulfillment: {
                        group: 'journalDetail.type',
                        usage: 'journalDetail.usageProjectedAnnual',
                        usage_percent: 'journalDetail.usagePercent',
                    },
                    oa: {
                        oa_status: 'journalDetail.oaType',
                        usage: 'journalDetail.usageProjectedAnnual',
                        usage_percent: 'journalDetail.percentOfAllUsage',
                    },
                    impact: {
                        impact: 'singleJournal.impact',
                        raw: 'journalDetail.rawProjectedAnnual',
                        weight: 'journalDetail.weight',
                        usage: 'journalDetail.usageContribution',
                    },
                    cost: {
                        cost_type: 'journalDetail.costType',
                        cost: 'journalDetail.costProjectedAnnual',
                        cost_per_paid_use: 'journalDetail.costTypePerPaidUse',
                    },
                }
                const map = keyMap[sectionType] || {}
                return headers.map(h => {
                    if (map[h.value]) {
                        return {...h, text: this.$t(map[h.value])}
                    }
                    // Dynamic year-based headers (e.g. usage_2024, cost_2024)
                    const usageYearMatch = h.value.match(/^usage_(\d{4})$/)
                    if (usageYearMatch) {
                        return {...h, text: h.text}
                    }
                    const costYearMatch = h.value.match(/^cost_(\d{4})$/)
                    if (costYearMatch) {
                        return {...h, text: h.text}
                    }
                    return h
                })
            },
        },
    };
</script>

<style scoped>

</style>